import * as React from "react";
import type { SVGProps } from "react";
const SvgLogoYoutube = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9.51 15.87a1 1 0 0 0 1-.01l5-3a1 1 0 0 0 0-1.72l-5-3A1 1 0 0 0 9 9v6a1 1 0 0 0 .51.87M11 13.23v-2.46L13.06 12z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7 20h10a5 5 0 0 0 5-5V9a5 5 0 0 0-5-5H7a5 5 0 0 0-5 5v6a5 5 0 0 0 5 5M4.879 6.879A3 3 0 0 1 7 6h10a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V9a3 3 0 0 1 .879-2.121"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgLogoYoutube;
